import React from 'react';
import { func, string } from 'prop-types';
import { IconButton } from '@picsio/ui';
import { Close } from '@picsio/icons';
import picsioConfig from '../../../../../config';
import l10n from '../../shared/strings';
import Tooltip from '../Tooltip';
import HelpButton from './HelpButton';
import Group from './Group';
import BrandedLogo from './BrandedLogo';

import Logo from './LogoSimple';

const { isMainApp } = picsioConfig;

const ToolbarImportTop = ({
  title = null,
  helpLink = null,
  helpText = null,
  onClose = null,
  logoUrl = null,
}) => (
  <div className="toolbar toolbarCatalogTop toolbarScreenTop">
    <Group>
      <Choose>
        <When condition={logoUrl}>
          <BrandedLogo src={logoUrl} rounded />
        </When>
        <When condition={!isMainApp}>
          <Logo additionalClass="logoPicsio disabled" />
        </When>
      </Choose>
    </Group>
    <Group additionalClass="assetNameWrapper breadCrumbs">
      <If condition={title}>
        <ul>
          <li>{title}</li>
        </ul>
      </If>
    </Group>
    <Group>
      <If condition={helpLink}>
        <HelpButton tooltipPosition="bottom" text={helpText} event="Help" component={helpLink} />
      </If>
      <If condition={onClose}>
        <Tooltip content={l10n.TOOLBARS.titleClose} placement="bottom">
          <IconButton
            id="button-screenClose"
            className="toolbarButton"
            onClick={onClose}
            size="xxl"
          >
            <Close />
          </IconButton>
        </Tooltip>
      </If>
    </Group>
  </div>
);

ToolbarImportTop.propTypes = {
  title: string,
  helpLink: string,
  helpText: string,
  logoUrl: string,
  onClose: func,
};

export default ToolbarImportTop;
